import mapboxgl from 'mapbox-gl';
import MapboxGeocoding from "@mapbox/mapbox-sdk/services/geocoding";
import * as turf from '@turf/turf';
import 'mapbox-gl/dist/mapbox-gl.css';

const _token = 'pk.eyJ1IjoiaGFsaS1idWVyb21vZWJlbCIsImEiOiJjbWd1Z2JqeHIwNHB5MmxzYjd5OHBtaHl2In0.5I_Q8gmqJ2czeacZV_eH_A';


function map() {
	const buttons = document.querySelectorAll('.openMap');

	buttons.forEach(function (button) {
		button.onclick = function () {
			document.getElementById('mapPopup').classList.add('active');
			document.body.style.overflow = 'hidden';
		};
	});

	const closeButton = document.getElementById('closeButton');

	if (closeButton) {
		closeButton.onclick = function () {
			document.getElementById('mapPopup').classList.remove('active');
			document.body.style.overflow = 'auto';
		};
	}

	if (document.querySelector(".map")) {
		mapboxgl.accessToken = _token;
		const geocodingClient = MapboxGeocoding({accessToken: _token});
		let originalGeoJSON = null;

		const map = new mapboxgl.Map({
			container: 'map',
			style: 'mapbox://styles/hali-bueromoebel/cmhw4gacl001a01s4fh6aexo0',
			center: [13.256113577563674, 47.73399838910318],
			zoom: 7,
		});

		map.scrollZoom.disable();
		map.addControl(new mapboxgl.NavigationControl());

		const locations = JSON.parse(map._container.dataset.posts);


		async function getCoordinates(address) {
			try {
				const response = await geocodingClient.forwardGeocode({
					query: address,
					limit: 1,
				}).send();

				const features = response.body.features;
				return features.length ? features[0].center : null;
			} catch (error) {
				console.error("Geocoding error:", error);
				return null;
			}
		}

		async function createGeoJSON(locations) {
			const features = [];

			for (const location of locations) {
				const fullAddress = `${location.street} ${location.house_nr}, ${location.city}, ${location.zip}`;
				const previewAddress = `${location.street} ${location.house_nr},  ${location.zip} ${location.city}`;
				const img = await loadImage(location);
				const coords = await getCoordinates(fullAddress);

				if (coords) {
					features.push({
						type: "Feature",
						geometry: {type: "Point", coordinates: coords},
						properties: {
							title: location.title,
							icon: img,
							fullAddress: previewAddress,
							img: location.img,
							tel: location.tel,
							email: location.email,
							link: location.permalink,
						}
					});
					location['coordinates'] = coords;
				} else {
					console.warn("Could not geocode:", fullAddress);
				}
			}

			return {
				type: "FeatureCollection",
				features
			};
		}

		async function loadImage(location) {
			return new Promise((resolve, reject) => {
				map.loadImage(location.bg.url, (error, image) => {
					if (error) {
						reject(error);
					} else {
						if (!map.hasImage('customIcon')) {
							map.addImage('customIcon', image);
						}
						resolve(image);
					}
				});
			});
		}

		async function customSearch(query) {
			const response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?types=postcode&country=AT&access_token=${mapboxgl.accessToken}`);
			const data = await response.json();

			if (data.features.length > 0) {
				const searchCoords = data.features[0].geometry.coordinates;
				const nearbyLocations = filterLocationsByProximity(searchCoords, locations, 80);

				if (nearbyLocations.length > 0) {
					const bounds = new mapboxgl.LngLatBounds();

					for (const nearbyLocation of nearbyLocations) {
						bounds.extend(nearbyLocation.coordinates);
						addPopup(nearbyLocation);
					}

					const camera = map.cameraForBounds(bounds, { padding: 150, maxZoom: 12 });

					if (camera) {
						const point = map.project(camera.center);
						if (window.innerWidth > 991) {
							point.x -= 10;
						} else {
							point.y -= 10;
						}
						const shiftedCenter = map.unproject(point);

						map.flyTo({
							center: shiftedCenter,
							zoom: camera.zoom,
							bearing: camera.bearing,
							pitch: camera.pitch,
							speed: 1.2,
							curve: 1.42
						});
					}

					document.querySelector("._text_notice_number span").innerText = nearbyLocations.length;
					document.querySelector(".error_wrapper").classList.add("active");
					document.querySelector("._text_notice_number").classList.add("active");

				} else {
					document.querySelector(".error_wrapper").classList.add("active");
					document.querySelector("._text_notice_none").classList.add("active");
				}
			} else {
				document.querySelector(".error_wrapper").classList.add("active");
				document.querySelector("._text_error_NaPLZ").classList.add("active");
			}
		}


		function filterLocationsByProximity(searchCoords, locations, maxDistanceKm) {
			return locations.filter(location => {
				try {
					const distance = turf.distance(searchCoords, location.coordinates, {units: "kilometers"});
					return distance <= maxDistanceKm;
				} catch (error) {
					return false;
				}
			});
		}



		async function initMapData(locations) {
			if (typeof createGeoJSON !== "function") {
				console.error("createGeoJSON is not defined.");
				return;
			}

			originalGeoJSON = await createGeoJSON(locations);

			map.addSource("locations", {
				type: "geojson",
				data: originalGeoJSON,
				cluster: true,
				clusterMaxZoom: 10,
				clusterRadius: 55,
			});

			map.addLayer({
				id: "clusters",
				type: "circle",
				source: "locations",
				filter: ["has", "point_count"],
				paint: {
					"circle-color": "#463CC8",
					"circle-radius": 25,
					"circle-opacity": 1
				}
			});

			map.addLayer({
				id: "cluster-count",
				type: "symbol",
				source: "locations",
				filter: ["has", "point_count"],
				layout: {
					"text-field": "{point_count_abbreviated}",
					"text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
					"text-size": 14,
				},
				paint: {
					"text-color": "#FFFFFF"
				}
			});

			map.addLayer({
				id: "icon-layer",
				type: "symbol",
				source: "locations",
				filter: ["!", ["has", "point_count"]],
				layout: {
					"icon-image": 'customIcon',
					"icon-size": 0.35,
					"icon-allow-overlap": true
				}
			});

			map.on("click", "clusters", (e) => {
				const features = map.queryRenderedFeatures(e.point, {layers: ["clusters"]});
				const clusterId = features[0].properties.cluster_id;

				map.getSource("locations").getClusterExpansionZoom(clusterId, (err, zoom) => {
					if (err) return;
					map.easeTo({center: features[0].geometry.coordinates, zoom});
				});
			});

			map.on("click", "icon-layer", (e) => {
				addPopup(e.features[0]);
			});

			if (map._container.dataset.uid) {
				const f = originalGeoJSON.features.find(f => {
					return f.properties.uid === map._container.dataset.uid;
				});

				map.flyTo({center: f.geometry.coordinates, zoom: 9});
			}

			map.on("mouseenter", "clusters", () => map.getCanvas().style.cursor = "pointer");
			map.on("mouseleave", "clusters", () => map.getCanvas().style.cursor = "");
			map.on("mouseenter", "icon-layer", () => map.getCanvas().style.cursor = "pointer");
			map.on("mouseleave", "icon-layer", () => map.getCanvas().style.cursor = "");
		}

		function addPopup(feature) {
			let title, fullAddress, img, coordinates, link, email, tel;

			document.querySelectorAll('.mapboxgl-popup').forEach(popup => {
				popup.classList.remove('open');
				popup.remove();
			});

			if (feature.properties) {
				({title, fullAddress, img, email, tel, link} = feature.properties);
				coordinates = feature.geometry.coordinates.slice();
			} else {
				({title, img, tel, email} = feature);
				fullAddress = feature.street + feature.house_nr + ',' + feature.city + feature.zip;
				coordinates = feature.coordinates.slice();
				link = feature.permalink;
			}

			if (fullAddress.includes(',')) {
				fullAddress = fullAddress.replace(',', '<br>');
			}

			let imgUrl = '';

			try {
				const imgObj = typeof img === 'string' ? JSON.parse(img) : img;
				imgUrl = imgObj?.url || '';
			} catch (e) {
				console.error('Invalid image JSON', e);
			}


			let html = `
				<div class="manufacturer_popup">
					<div class="imgContainer">
						<img src="${imgUrl}" alt="Showroom" />
					</div>
					<div class="textContainer">
						<div class="title">${title}</div>
							<div class="address">${fullAddress}</div>
							<div class="contacts">
								<div class="telEmail">
								<a href="tel: ${tel}" class="contactLink">
                                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <mask id="mask0_1308_7453" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
    <path d="M16 0H0V16H16V0Z" fill="white"/>
  </mask>
  <g mask="url(#mask0_1308_7453)">
    <path d="M12.8334 9.95333V12.1533C12.8334 12.9733 12.1068 13.6 11.2934 13.4867C6.4001 12.8067 2.52677 8.93333 1.84677 4.04C1.73344 3.22667 2.3601 2.5 3.1801 2.5H5.3801C5.70677 2.5 5.98677 2.73333 6.0401 3.05333L6.3001 4.51333C6.39344 5.02667 6.1801 5.54667 5.75344 5.84667L5.1601 6.26667C6.11344 7.87333 7.46676 9.21333 9.0801 10.16L9.48676 9.58C9.78676 9.15333 10.3068 8.94 10.8201 9.03333L12.2801 9.29333C12.6001 9.35333 12.8334 9.62667 12.8334 9.95333Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.8335 6.16675H9.8335V3.16675" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.85352 6.14667L13.5002 2.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
</svg>
								<span class="text">${tel}</span>
									
								</a>
								<a href="mailto: ${email}" class="contactLink">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <mask id="mask0_1308_8248" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
    <path d="M16 0H0V16H16V0Z" fill="white"/>
  </mask>
  <g mask="url(#mask0_1308_8248)">
    <path d="M13.5002 3.16675H2.50016C2.13198 3.16675 1.8335 3.46522 1.8335 3.83341V12.1667C1.8335 12.5349 2.13198 12.8334 2.50016 12.8334H13.5002C13.8684 12.8334 14.1668 12.5349 14.1668 12.1667V3.83341C14.1668 3.46523 13.8684 3.16675 13.5002 3.16675Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.1668 4.8335L9.3085 9.0353C8.55723 9.68503 7.4431 9.68503 6.69183 9.0353L1.8335 4.8335" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
</svg>
									<span class="text">${email}</span>
								</a>
</div>
								<a href="${link}" class="moreLink">
								mehr erfahren
								</a>
							</div>
						</div>
					</div>
					<svg class="bottomArrow" xmlns="http://www.w3.org/2000/svg" width="49" height="75" viewBox="0 0 49 75" fill="none">
  <defs>
    <filter id="dropShadow" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="0" stdDeviation="5" flood-color="rgba(0,0,0,0.15)" />
    </filter>
  </defs>
  <path 
    d="M37.8097 36.7578C41.6299 36.758 44.0383 40.8683 42.171 44.2012L28.8624 67.957C26.9529 71.3649 22.0473 71.365 20.1378 67.957L6.82924 44.2012C4.96196 40.8683 7.37119 36.7578 11.1915 36.7578H37.8097Z" 
    fill="white" 
    filter="url(#dropShadow)" 
  />
</svg>

				</div>`;

			new mapboxgl.Popup({
				focusAfterOpen: false,
				anchor: 'bottom'
			})
			.setLngLat(coordinates)
			.setHTML(html)
			.addTo(map);

		}

		function filterFeaturesByCategories(categoryIDs) {
			const source = map.getSource("locations");
			if (!source || !originalGeoJSON) return;

			const filteredFeatures = originalGeoJSON.features.filter(feature =>
				feature.properties.categories.some(category => categoryIDs.includes(category.ID))
			);

			source.setData({
				type: "FeatureCollection",
				features: filteredFeatures
			});

			if (filteredFeatures.length > 0) {
				const bounds = new mapboxgl.LngLatBounds();
				filteredFeatures.forEach(feature => bounds.extend(feature.geometry.coordinates));
			}
		}

		async function resetMap() {
			const source = map.getSource("locations");
			if (!source || !originalGeoJSON) return;

			source.setData(originalGeoJSON);

			const bounds = new mapboxgl.LngLatBounds();
			originalGeoJSON.features.forEach(feature => bounds.extend(feature.geometry.coordinates));
		}

		function removeActiveClasses(form) {
			form.classList.remove("_error_NaN", "_error_length");
			document.querySelector("._text_error_NaN").classList.remove("active");
			document.querySelector("._text_error_NaPLZ").classList.remove("active");
			document.querySelector("._text_error_length").classList.remove("active");
			document.querySelector("._text_notice_none").classList.remove("active");
			document.querySelector("._text_notice_number").classList.remove("active");
			document.querySelector(".error_wrapper").classList.remove("active");
		}

		async function initSearchFilterBox() {
			const form = document.querySelector('.filterbox form.search-wrapper');
			if (!form) {
				return null;
			}

			const filterOpener = document.querySelector('.filterbox .filter-opener');
			const filterWrapper = document.querySelector('.filterbox .filter-wrapper');
			const filters = document.querySelectorAll('.filterbox .filter-wrapper .filter');

			const search = form.querySelector("input.search");
			search.removeAttribute("disabled");

			const submitBtn = form.querySelector("button[type='submit']");
			submitBtn.removeAttribute("disabled");

			const resetBtn = form.querySelector("button[type='reset']");
			resetBtn.removeAttribute("disabled");

			const useLocationCheckbox = document.getElementById("useCurrentLocation");

			if (useLocationCheckbox) {
				useLocationCheckbox.addEventListener("change", async function () {
					if (useLocationCheckbox.checked) {
						if (navigator.geolocation) {
							navigator.geolocation.getCurrentPosition(async (position) => {
								const lng = position.coords.longitude;
								const lat = position.coords.latitude;
								const geocodingClient = MapboxGeocoding({accessToken: mapboxgl.accessToken});

								const response = await geocodingClient.reverseGeocode({
									query: [lng, lat],
									types: ["postcode"],
									limit: 1,
								}).send();

								if (response.body && response.body.features && response.body.features.length > 0) {
									search.value = response.body.features[0].text;
									resetBtn.classList.add('active');

									form.dispatchEvent(new Event('submit', {bubbles: true}));

								} else {
									alert("Postleitzahl konnte nicht gefunden werden.");
									useLocationCheckbox.checked = false;
								}

							}, () => {
								alert("Standort konnte nicht abgerufen werden.");
								useLocationCheckbox.checked = false;
							});
						} else {
							alert("Geolocation wird nicht unterstützt.");
							useLocationCheckbox.checked = false;
						}
					} else {
						removeActiveClasses(form)
						form.querySelector("button[type='reset']").classList.remove("active");
						removeActiveClasses(form)
						document.getElementById("useCurrentLocation").checked = false;
						document.querySelectorAll('.mapboxgl-popup').forEach(popup => {
							popup.classList.remove('open');
							popup.remove();
						});
						map.flyTo({
							center: [13.256113577563674, 47.73399838910318],
							zoom: 7,
						});
						search.value = "";
						resetBtn.classList.remove("active");
					}
				});
			}

			search.addEventListener("keyup", function (ev) {
				if (!resetBtn.classList.contains('active') && search.value) {
					resetBtn.classList.add('active');
				}
				if (search.value === "") {
					resetBtn.classList.remove('active');
				}
			});

			form.addEventListener("reset", function (ev) {
				document.querySelectorAll('.mapboxgl-popup').forEach(popup => {
					popup.classList.remove('open');
					popup.remove();
				});
				form.querySelector("button[type='reset']").classList.remove("active");
				removeActiveClasses(form)
				document.getElementById("useCurrentLocation").checked = false;
				map.flyTo({
					center: [13.256113577563674, 47.73399838910318],
					zoom: 7,
				});
				return false;
			});

			form.addEventListener("submit", function (ev) {
				ev.preventDefault();
				removeActiveClasses(form)

				const plz = ev.target[0].value;
				if (!plz) {
					map.flyTo({
						center: [13.256113577563674, 47.73399838910318],
						zoom: 7,
					});
					return false;
				}


				if (isNaN(parseInt(plz))) {
					form.classList.add("_error_NaN");
					document.querySelector(".error_wrapper").classList.add("active");
					document.querySelector("._text_error_NaN").classList.add("active");
					return false;
				}

				if (plz.length !== 4) {
					form.classList.add("_error_length");
					document.querySelector(".error_wrapper").classList.add("active");
					document.querySelector("._text_error_length").classList.add("active");
					return false;
				}

				customSearch(plz);
			});

			if (filterOpener) {
				filterOpener.addEventListener("click", function (ev) {
					filterOpener.classList.toggle("active");
					filterWrapper.classList.toggle("active");
				});
			}

			for (const filter of filters) {
				filter.addEventListener("click", function () {

					const uid = filter.dataset.loc;
					const location = locations.find(loc => loc.uid === uid);

					if (location && Array.isArray(location.coordinates)) {
						const lng = location.coordinates[0];
						const lat = location.coordinates[1];

						if (!isNaN(lat) && !isNaN(lng)) {
							const point = map.project([lng, lat]);

							if (window.innerWidth > 991) {
								point.x -= 10;
							} else {
								point.y -= 10;
							}

							const shiftedCenter = map.unproject(point);

							map.flyTo({
								center: shiftedCenter,
								zoom: 12,
								speed: 1.2,
								curve: 1.42
							});

							filterOpener.classList.toggle("active");
							filterWrapper.classList.toggle("active");

							addPopup(location);
						}
					} else {
						console.error("Location not found or coordinates missing", uid);
					}

					const activeFilters = document.querySelectorAll('.filterbox .filter-wrapper .filter.active');
					if (activeFilters.length > 0) {
						const categoryIDs = [];
						for (const activeFilter of activeFilters) {
							categoryIDs.push(parseInt(activeFilter.dataset.filter));
						}
						filterFeaturesByCategories(categoryIDs);
					} else {
						resetMap();
					}
				});
			}
		}


		map.on("load", async () => {
			try {
				await initMapData(locations).then(() => {
					initSearchFilterBox();
				});

			} catch (error) {
				console.error("Error initializing clustered markers:", error);

			}
		});
	}
}

export {map};